import React from 'react'
import { OrdersContext } from 'contexts/OrdersContext'
import {
  DcButton,
  DcDiv,
  DcInput,
  DcText,
  PixelFactoryContext,
  PixelFlexBox,
} from 'pixel-base'

import { addOrderTag } from 'utils/api-routes.util'
import { IPixelFactory } from '../../../../../../decl.d'

const AddNewTagForm = (props) => {
  const { getAllOrderMeta } = React.useContext(OrdersContext)

  const { handleClose } = props
  const { showSuccess, showFailure, showPageLoader, hidePageLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const [data, setData] = React.useState({
    tag_name: '',
    tag_description: '',
  })
  const [error, setError] = React.useState({
    error: '',
    field: '',
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    handleAddTag()
  }

  const handleAddTag = () => {
    addOrderTag(data).subscribe((res: any) => {
      showPageLoader()
      if (!res.response.error) {
        hidePageLoader()
        showSuccess('Successfully Added')
        setData({
          tag_name: res.response.tag_name,
          tag_description: res.response.tag_description,
        })
        getAllOrderMeta()
        handleClose(res.response, 'add')
      } else {
        hidePageLoader()
        if (res.response.error && res.response.field) {
          setError({
            error: res.response.error,
            field: res.response.field,
          })
        } else {
          showFailure(res.response.error)
          hidePageLoader()
        }
      }
    })
  }
  return (
    <>
      <form
        style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
        onSubmit={handleSubmit}
      >
        <PixelFlexBox
          justifyContent="flex-start"
          width="100%"
          style={{ flexGrow: '1' }}
        >
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Tag Name
            </DcText>
            <DcInput
              error={
                error.field === 'tag_name' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'text'}
              name={'Tag Name'}
              placeholder={'Tag Name'}
              value={data.tag_name}
              onChange={(e) => setData({ ...data, tag_name: e.target.value })}
            />
          </DcDiv>
        </PixelFlexBox>
        <PixelFlexBox
          justifyContent="flex-start"
          width="100%"
          style={{ flexGrow: '1' }}
        >
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Tag Description
            </DcText>
            <DcInput
              error={
                error.field === 'tag_description' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'text'}
              as={'textarea'}
              name={'tag description'}
              placeholder={'Tag Description'}
              value={data.tag_description}
              onChange={(e) =>
                setData({ ...data, tag_description: e.target.value })
              }
            />
          </DcDiv>
        </PixelFlexBox>
        <PixelFlexBox
          justifyContent="flex-end"
          width="100%"
          style={{ flexGrow: '1' }}
        >
          <DcButton size="sm" variant="primary" type="submit">
            Save
          </DcButton>
        </PixelFlexBox>
      </form>
    </>
  )
}

export default AddNewTagForm
